import { Component, OnInit, Input, forwardRef, EventEmitter, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'service-checkbox',
    templateUrl: './servicecheckbox.component.html',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ServiceCheckboxComponent),
            multi: true
        }],
    imports: [NgClass]
})
export class ServiceCheckboxComponent implements OnInit, ControlValueAccessor {

  @Input() disabled = false;
  @Input() binary = true;
  @Output() changeEvent = new EventEmitter();

  isSelected: boolean;

  writeValue(obj: any): void {
    this.isSelected = obj;
  }
  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void { }

  // call if value was changed inside our component
  private _onChange = (_: any) => { return _};
  // call if input was "touched" .. !
  private _onTouched = () => { };

  constructor() { }

  ngOnInit() { }

  toggleCheckbox() {
    if (this.disabled) {
      return;
    }
    if (this.isSelected === true) {
      this.isSelected = false;
      this.binary = false;
    } else if (this.isSelected === false) {
      if (this.binary) {
        this.isSelected = true;
      } else {
        this.isSelected = null;
      }
    } else {
      this.isSelected = true;
    }
    this._onChange(this.isSelected);
    this.changeEvent.emit(this.isSelected);
  }
}
